import { Component, EventEmitter, Inject, OnDestroy, OnInit, Output } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormArray, FormBuilder, FormControl, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { FiltersService } from '../../../../services/base/filters.service';
import { takeUntil } from 'rxjs/operators';
import { TaskService } from '../../../../services/tasks/task.service';
import { AddressBook } from '../../../../interfaces/configuration/address-book';
import { ServerResponse } from '../../../../interfaces/base/server.response';
import { ApiService } from '../../../../services/base/api.service';
import { QuillService } from '../../../../services/base/quill.service';
import { FormService } from '../../../../services/base/form.service';
import { Filters } from '../../../../interfaces/base/filters';

@Component({
  selector: 'fury-forward-task-dialog',
  templateUrl: './forward-dialog.component.html',
  styleUrls: ['./forward-dialog.component.scss'],
})

export class ForwardDialogComponent implements OnInit, OnDestroy {

  @Output() submitData: EventEmitter<any> = new EventEmitter<any>();

  public filters: Filters = {
    addressBook: {
      preload: true,
      isLoading: false,
      data: <AddressBook[]>[]
    },
  };

  public isLoading: boolean = false;

  public form = this.fb.group({
    address_book_id: null,
    emails: this.fb.array([]),
    note: null,
  });

  private destroy$: Subject<null> = new Subject<null>();

  constructor(@Inject(MAT_DIALOG_DATA) public data: number,
              private fb: FormBuilder,
              private filtersService: FiltersService,
              private taskService: TaskService,
              private api: ApiService,
              public quillService: QuillService,
              public formService: FormService,
  ) {
  }

  ngOnInit(): void {
    this.filtersService.filters = this.filters;
    Object.keys(this.filters).map((key: string): void => {
      if (this.filters[key].preload) {
        this.filters[key].isLoading = true;

        this.filtersService[key]().pipe(takeUntil(this.destroy$)).subscribe((data: any): void => {
          this.filters[key].data = data;
          this.filters[key].isLoading = false;
        });
      }
    });
  }

  addEmail(): void {
    const element: FormArray = this.form.controls.emails as FormArray;
    element.push(new FormControl('', [Validators.required, Validators.email]));
  }

  removeEmail(index: number): void {
    const element: FormArray = this.form.controls.emails as FormArray;
    element.removeAt(index);
  }

  submit(): void {
    this.isLoading = true;

    this.taskService.forward(this.data, this.form.value).pipe(takeUntil(this.destroy$)).subscribe(
      (response: ServerResponse): void => {
        if (!this.api.isErrorResponse(response)) {
          this.submitData.next();
        }
        this.isLoading = false;
      },
      (): void => {
        this.isLoading = false;
      }
    );
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();

    this.isLoading = false;
  }
}
